import { RemoteMarkDirectorNotificationAsRead } from 'data/usecases/notifications';
import { makeApiUrlDirectorNotifications } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteMarkDirectorNotificationAsRead =
  (): RemoteMarkDirectorNotificationAsRead => {
    return new RemoteMarkDirectorNotificationAsRead(
      makeApiUrlDirectorNotifications(),
      makeAxiosHttpClient(),
    );
  };
